import { Box, Stack, Text } from '@ltvco/refresh-lib/theme';
import { FC } from 'react';

import {
  RecallsCardsGrid,
  RecallsCardViewMoreButton,
  RecallsCardViewMoreButtonMobile,
} from './components';
import { RecallCard } from './RecallCard';

import type { NormalizedRecallCard } from '../interfaces';

export interface RecallsCardSectionProps {
  title: string;
  cards: NormalizedRecallCard[];
  onViewMore?: () => void;
  onCardClick?: (card: NormalizedRecallCard) => void;
}

export const RecallsCardSection: FC<RecallsCardSectionProps> = ({
  title,
  cards,
  onViewMore,
  onCardClick,
}) => {
  return (
    <Box sx={{ mb: 4 }}>
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        sx={{ mb: 2 }}
      >
        <Text
          component="h3"
          sx={{
            fontWeight: 700,
            fontSize: 24,
            m: 0,
          }}
        >
          {title}
        </Text>
        {onViewMore && (
          <RecallsCardViewMoreButton
            variant="text"
            color="primary"
            onClick={onViewMore}
          >
            View More
          </RecallsCardViewMoreButton>
        )}
      </Stack>
      <RecallsCardsGrid>
        {cards.map((card) => (
          <RecallCard
            key={card.recallNumber ?? `${card.recallType}-${card.title}`}
            card={card}
            onClick={onCardClick ? () => onCardClick(card) : undefined}
          />
        ))}
      </RecallsCardsGrid>
      {onViewMore && (
        <RecallsCardViewMoreButtonMobile
          variant="outlined"
          color="primary"
          onClick={onViewMore}
        >
          View More
        </RecallsCardViewMoreButtonMobile>
      )}
    </Box>
  );
};
